import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    progressContainer: { paddingTop: '3rem' },
    topSection: {
        minHeight: '100%',
        background: theme?.app?.clientTheme.colors.primaryColorDark ||
            '#0A2240',
        color: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF'
    },
    header: {
        fontSize: '26px',
        '& p': { marginBottom: '.5rem' }
    },
    checkmarkContainer: {
        marginBottom: '1rem',
        marginTop: '2rem',
        cursor: 'pointer' as const,
        fontSize: '22px',
        userSelect: 'none' as const
    },
    buttonContainer: { fontSize: '20px' },
    termsContent: {
        height: '700px',
        width: '100%',
        overflowY: 'scroll' as const
    },
    checkmarkInput: {
        cursor: 'pointer' as const,
        height: '23px',
        width: '23px',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.white || '#FFFFFF'}`,
        marginTop: '3px',
        '&:after': {
            content: 'url(\'Images/checkbox.svg\')',
            position: 'relative' as const,
            display: 'none',
            left: '-1px',
            top: '-1px'
        }
    }
});